import React from 'react';
import PropTypes from 'prop-types';
import { getUserResponse } from '../../shared/answer-helpers';
import { ARCHETYPE_CONTENT, getBookArchetype } from '../../shared/book-archetype-helpers';
import { getBookCover } from '../../shared/book-covers';
import styles from './PreSaleSlide.css';

const WRITTEN_FOR_BY_DEDICATION_ID = {
    1: 'your mother',
    2: 'your children',
    3: 'you, finally',
    4: 'everyone who said you couldn’t'
};

function PreSaleSlide({ results }) {
    const { userResponses } = results;
    const name = getUserResponse(userResponses, 9114)?.text;
    const titleResponse = getUserResponse(userResponses, 9111);
    const writtenFor = WRITTEN_FOR_BY_DEDICATION_ID[getUserResponse(userResponses, 9112)?.id];
    const { chaptersFor } = ARCHETYPE_CONTENT[getBookArchetype(userResponses)];

    return (
        <section className={styles.root}>
            <div className={styles.head}>
                <p className={styles.eyebrow}>Your plan is ready</p>
                <h2 className={styles.title}>{titleResponse?.text}</h2>
                {Boolean(name) && <p className={styles.author}>by {name}</p>}
            </div>
            <img src={getBookCover(userResponses)} alt='' className={styles.cover} />
            <ul className={styles.plan}>
                <li>Your <strong>digital book</strong>, 7 chapters for {chaptersFor}</li>
                <li>Personal questions, starting with your genre</li>
                <li>Speak or type, and we write it up in your voice</li>
                {Boolean(writtenFor) && <li>Written for {writtenFor}. Shared with one private link.</li>}
                <li>First chapter this week, the whole book in about <strong>12 weeks</strong></li>
            </ul>
        </section>
    );
}

PreSaleSlide.propTypes = {
    results: PropTypes.shape({ userResponses: PropTypes.array }).isRequired
};

export {
    PreSaleSlide
};
